import type { MiddlewareContext, Middleware } from '@/types/router';
import type { NavigationGuardNext } from 'vue-router';

function middlewarePipeline(
    context: MiddlewareContext,
    middleware: Middleware[],
    index: number
): NavigationGuardNext {
    const nextMiddleware = middleware[index];

    if (!nextMiddleware) return context.next;

    return () => {
        const nextPipeline = middlewarePipeline(context, middleware, index + 1);
        nextMiddleware({ ...context, next: nextPipeline });
    };
}

export default middlewarePipeline;
